import { useEffect, useState } from "react";
import { istHomescreenApp } from "@/portal/listenApi";

/* Einmal global gefangenes beforeinstallprompt (Android/Chromium) – für Einstieg und Installations-Einladung. iOS kennt kein Prompt. */
let ereignis = null;
const abos = new Set();
const INSTALLIERT = "robbie_installiert";
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); ereignis = e; abos.forEach((f) => f(true)); });
  window.addEventListener("appinstalled", () => { ereignis = null; try { localStorage.setItem(INSTALLIERT, "1"); } catch { /* privat */ } abos.forEach((f) => f(false)); });
}

export const istInstalliert = () => istHomescreenApp() || (typeof localStorage !== "undefined" && localStorage.getItem(INSTALLIERT) === "1");

/* Anmeldungen pro Gerät zählen – einmal je Browser-Sitzung. So erscheint die Installations-Einladung frühestens ab der zweiten Anmeldung. */
const LOGIN_COUNT = "robbie_login_count";
const LOGIN_SESSION = "robbie_login_sitzung";
export const zaehleKundenLogin = () => {
  try {
    if (sessionStorage.getItem(LOGIN_SESSION)) return Number(localStorage.getItem(LOGIN_COUNT) || 0);
    sessionStorage.setItem(LOGIN_SESSION, "1");
    const n = Number(localStorage.getItem(LOGIN_COUNT) || 0) + 1;
    localStorage.setItem(LOGIN_COUNT, String(n));
    return n;
  } catch { return 0; }
};
export const kundenLoginAnzahl = () => { try { return Number(localStorage.getItem(LOGIN_COUNT) || 0); } catch { return 0; } };
/** iPhone: Safari meldet keine Installation – der Kunde bestätigt nach den drei Schritten selbst. */
export const markiereInstalliert = () => { try { localStorage.setItem(INSTALLIERT, "1"); } catch { /* privat */ } };
export const istAndroid = () => /Android/i.test(navigator.userAgent);
/** In-App-Browser (WhatsApp/Facebook/Instagram-WebView): iOS ohne Safari-Kennung bzw. Android-WebView – eigene Cookies, nicht die Home-Bildschirm-App. */
export const istInAppBrowser = () => { const ua = navigator.userAgent; return !istHomescreenApp() && (/\bwv\b|; wv\)|FBAN|FBAV|Instagram|WhatsApp|Line\//i.test(ua) || (/iphone|ipad|ipod/i.test(ua) && !/Safari\//i.test(ua))); };
/** iOS-Browser außer Safari (Chrome/Firefox/Edge/Opera/DuckDuckGo … auf iOS) können die PWA nicht installieren – dort „In Safari öffnen“. */
export const istIOSFremdbrowser = () => /CriOS|FxiOS|EdgiOS|OPT\/|DuckDuckGo|Brave|YaBrowser|GSA\//i.test(navigator.userAgent) || (/iphone|ipad|ipod/i.test(navigator.userAgent) && !/Safari/i.test(navigator.userAgent));

export const useInstallPrompt = () => {
  const [kann, setKann] = useState(Boolean(ereignis));
  useEffect(() => { abos.add(setKann); return () => abos.delete(setKann); }, []);
  const installieren = async () => {
    if (!ereignis) return null;
    ereignis.prompt();
    const r = await ereignis.userChoice.catch(() => null);
    ereignis = null; setKann(false);
    if (r?.outcome === "accepted") { try { localStorage.setItem(INSTALLIERT, "1"); } catch { /* privat */ } }
    return r?.outcome || null;
  };
  return [kann, installieren];
};
